<template>
  <div>
    <div class="mb-2">
      <span 
        v-if="!!discount" 
        class="px-2 py-1 fw-bold color-sachlich-white bg-expinet-darkblue"
      >
        inkl. &nbsp; <Price :amount="discount.amount" /> &nbsp; {{ discount.description }}
      </span>
  
      <span
        v-if="!!campaignEnd" 
        class="px-2 py-1 ms-1 fw-bold color-sachlich-white bg-aida-red"
      >
        Aktionspreis buchbar bis {{ campaignEnd }}
      </span>
    </div>

    <div 
      v-for="(item, index) in items"
      :key="index"
      class="lh-base"
    >
      <i 
        class="fa"
        :class="iconClass(item)" 
      />
      &nbsp;
      {{ item.description }}
    </div>

    <div v-if="isFlexFlight">
      <i class="icon fa fa-info-circle" />
      &nbsp; Nur Festbuchung, Namensänderungen sind nicht möglich
    </div>
  </div>
</template>

<script lang="ts">
import { useCruiseListStore, useCruiseStore, useDetailsStore, usePriceStore } from '@/store'
import { useCatalogStore } from '@/store/catalog'
import { Extra } from '@/store/details/cruise/interfaces'
import dayjs from 'dayjs'
import { filter } from 'lodash-es'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { DEFAULT_DATE_FORMAT } from '../../../general/helper'
import { flexFlightPriceModels } from '../../../general/master-data'
import Price from '../../common/Price.vue'

export default defineComponent({
  components: {
    Price
  },
  computed: {
    ...mapState(useCruiseListStore, {
      selectedEntryId: store => store.selectedEntryId
    }),
    ...mapState(useDetailsStore, {
      priceModel: store => store.priceModel,
      transportation: store => store.transportation,
      paxConfig: store => store.paxConfig,
    }),
    ...mapState(useCruiseStore,{
      cruise: store => store.cruise
    }),
    ...mapState(useCatalogStore, {
      cruises: store => store.cruises
    }),
    ...mapState(usePriceStore, {
      extras: 'extrasForCabin',
    }),

    campaignEnd() {
      if (this.cruise?.campaignEnd) {
        return dayjs(this.cruise.campaignEnd).format(DEFAULT_DATE_FORMAT)
      }
      
      return null
    },
    value() {
      const paxCount = this.paxConfig?.total

      if  (!paxCount) {
        return null
      }

      return paxCount > 1 ? 50 : 25
    },
    isFlexFlight() {
      const isFlexFlightPriceModel = !!this.priceModel ? !!flexFlightPriceModels.includes(this.priceModel) : false
      const isFlexFlightSelected = this.transportation === 'Wunschflug'

      return isFlexFlightPriceModel && isFlexFlightSelected
    },
    items() {
      return filter(this.extras, extra => extra.type === 'info' || extra.type === 'gift')
    },

    discount() {
      const discounts = this.extras?.filter((extra) => extra.type === 'discount')
      if (!!discounts?.length) {
        return discounts[0]
      }
      return null
    },
  },
  methods: {
    iconClass: (item: Extra) => {
      switch (item.type) {
        case 'info':
          return 'fa-info-circle color-expinet-blue'
        case 'gift':
          return 'fa-check color-aida-green'
      }
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.icon {
  color: $color-expinet-blue;
}
</style>
